import Globals from "../../Globals"
import moment from 'moment';
import Avatar from '../../assets/img/plano-de-saude.svg';
import OnOff from "../svgDinamico/onOff";

export default function ({ index, professional, onClick }) {
    return (
        <div onClick={onClick} key={professional.id} className='col-12' style={{ padding: '0px 10px' }}>
            <div>
                <div style={{ position: 'relative' }} className='card-list row'>
                    <div style={{ position: "absolute", width: 'auto', top: 10, right: 10 }}>
                        <OnOff isSwitchOn={professional.current_status} />
                    </div>
                    {professional.image === "" || professional.image === null || professional.image === undefined ? (
                        <div className='avatar-img col-1'>
                            <img alt='avatar' src={Avatar} />
                        </div>
                    ) : (
                        <div style={{ background: 'url(' + Globals.BASE_URL + '/storage/' + professional.image + ') 0% 0% / cover' }} className='card-list-img col-1'></div>
                    )}

                    <div className='d-flex col-9 col-sm-3 flex-column'>
                        <span className='card-list-name card-list-name-big-info'>{professional.name}</span>
                        <span className='card-list-name card-list-name-big-info'>{professional.council_name + '-' + professional.council_state + " " + professional.council_number}</span>
                    </div>

                    <div style={{ marginTop: 5 }} className='d-flex col-12 col-sm-4 flex-column'>
                        <span className='card-list-name'>{professional.last_login_date && moment(professional.last_login_date).format('DD/MM/YYYY HH:mm')} {professional.last_logout_date != null && ("à " + moment(professional.last_logout_date).format('DD/MM/YYYY HH:mm'))}</span>
                        <span className='card-list-name'>{professional.qntAttendances} atendimento(s)</span>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: 5 }} className='col-12 col-sm-3'>
                        <div style={{ display: 'flex', gap: 4, justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                            {professional.specialty.map((specialty, idx) => (
                                <div key={idx} className='specialty-card'>
                                    {specialty}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}